import { FC, PropsWithChildren } from "react";
import Footer from "components/layout/footer";
import Header from 'components/layout/header';

type CommonLayoutProps = PropsWithChildren<unknown>;

const CommonLayout: FC<CommonLayoutProps> = ({ children }: CommonLayoutProps) => {
  return (
    <div className="app app-layout-common">
      <Header />
      <div className="app-content">{children}</div>
      <Footer />
    </div>
  );
};

export default CommonLayout;
